{
  "brand": "VBB PLAY",
  "tagline": "Premium o‘yin platformasi",
  "loading": "Yuklanmoqda…",
  "retry": "Qayta urinish",
  "close": "Yopish",
  "search": "Qidirish",
  "seeAll": "Hammasini ko‘rish",
  "comingSoon": "Tez orada",
  "currency": "AZN",
  "language": "Til",
  "selectLanguage": "Tilni tanlang",
  "offlineHint": "Aloqa tekshirilmoqda",
  "footerRights": "© {{year}} VBB PLAY. Barcha huquqlar himoyalangan.",
  "footerSupport": "Qo‘llab-quvvatlash",
  "heroEyebrow": "PLAY BEYOND LIMITS",
  "heroTitle": "Katta o‘yinlar. Dadil yutuqlar.",
  "heroSubtitle": "Chegaralarni yoring — premium lobbi, xavfsiz kassa va tanlangan o‘yin katalogi.",
  "heroCta": "Hozir o‘ynash",
  "promoFallbackTitle": "VBB PLAY bonus klubi",
  "promoFallbackSubtitle": "Bonus va VIP dasturi tayyorlanmoqda. Bildirishnomalar tez orada faollashadi.",
  "promoFallbackCta": "Tez orada",
  "login": "Kirish",
  "promoFilter_all": "All",
  "promoFilter_welcome": "Welcome",
  "promoFilter_casino": "Casino",
  "promoFilter_sports": "Sports",
  "promoFilter_vip": "VIP",
  "storyBonuses": "Bonuslar",
  "storyVip": "VIP",
  "storyCashback": "Cashback",
  "storyCrypto": "Kripto",
  "bonusSelectTitle": "Bonus tanlang",
  "continue": "Davom et",
  "supportWelcome": "VBB PLAY ga xush kelibsiz",
  "supportPrechat": "Muloqotdan oldin aloqa va savolingizni yozing.",
  "supportEmail": "Email",
  "supportName": "Ism",
  "supportMessage": "Xabar",
  "supportConsent": "Shaxsiy malumotlarni qayta ishlashga roziman.",
  "startDialogue": "Muloqotni boshlash",
  "attach": "Biriktirish",
  "send": "Yuborish",
  "support247": "Yordam 24/7",
  "supportInvite": "Operatorlar yordamga tayyor.",
  "contactSupport": "Yordam bilan boglanish",
  "infoSection": "Malumot",
  "referral": "Referal",
  "liveSports": "Jonli",
  "prematch": "Prematch",
  "fiatMethods": "Fiat",
  "fiatMethodsHint": "Karta, M10, Terminal",
  "cryptoMethodsHint": "Kassada qo‘llab-quvvatlanadigan kriptovalyutalar",
  "personalInfo": "Shaxsiy malumotlar",
  "contactInfo": "Aloqa",
  "displayName": "Ism",
  "notAvailable": "Mavjud emas",
  "phone": "Telefon",
  "profileEditHint": "Ism, tugilgan sana va jins hisobingizda saqlanadi.",
  "myProfile": "Profilim",
  "securitySettings": "Xavfsizlik",
  "rewardCenter": "Mukofot markazi",
  "notificationsTitle": "Bildirishnomalar",
  "markAllRead": "Hammasini o‘qilgan qilish",
  "marketingOptIn": "Promo bildirishnomalarni olish",
  "emptyNotifications": "Bildirishnoma yo‘q",
  "notificationsUnavailable": "Hodisa bildirishnomalari shu yerda ko‘rinadi.",
  "open": "Ochish",
  "protectionTitle": "Hisob himoyasi",
  "coolingOff": "Sovutish muddati",
  "selfExclude": "O‘zini cheklash",
  "requestClosure": "Hisobni yopishni so‘rash",
  "helpSupport": "Yordam",
  "promoCode": "Promo kod",
  "redeem": "Faollashtirish",
  "bonusHistory": "Bonus tarixi",
  "promoLoginRequired": "Kodni faollashtirish uchun kiring.",
  "promoSuccess": "{{amount}} AZN hisobingizga qoshildi",
  "promo_invalid_code": "Bu kod yaroqsiz.",
  "promo_campaign_expired": "Aksiya muddati tugagan.",
  "promo_campaign_inactive": "Aksiya faol emas.",
  "promo_campaign_not_started": "Aksiya hali boshlanmagan.",
  "promo_per_user_limit": "Siz bu kodni allaqachon ishlatgansiz.",
  "promo_unique_user_limit": "Aksiya foydalanuvchi limiti tulgan.",
  "promo_usage_limit": "Bu aksiya uchun faollashtirish qolmadi.",
  "promo_not_eligible": "Siz bu aksiyaga mos emassiz.",
  "promo_minimum_deposit_not_satisfied": "Mos depozit talab qilinadi.",
  "promo_budget_exhausted": "Aksiya byudjeti tugagan.",
  "promo_too_many_requests": "Juda kop urinish. Keyinroq urinib koring.",
  "promo_zero_reward": "Bu aksiyaning bu yerda pul mukofoti yoq.",
  "promo_redeem_failed": "Kodni faollashtirib bolmadi.",
  "storyPromo": "Promo kod",
  "liveSupport": "Jonli yordam",
  "sportsUnavailable": "Sport tikish hozircha mavjud emas. Kazino ochiq.",
  "linked": "Ulangan",
  "notLinked": "Ulanmagan",
  "loadFailed": "Yuklanmadi",
  "unavailableTitle": "Mavjud emas",
  "vipUnavailable": "VIP darajalar hali sozlanmagan.",
  "givenName": "Ism",
  "familyName": "Familiya",
  "dateOfBirth": "Tugilgan sana",
  "gender": "Jins",
  "genderMale": "Erkak",
  "genderFemale": "Ayol",
  "genderOther": "Boshqa",
  "genderPreferNot": "Aytishni istamayman",
  "saveProfile": "Profilni saqlash",
  "profileSaved": "Profil saqlandi",
  "profileSaveFailed": "Profil saqlanmadi",
  "identityLockedNotice": "Shaxsiy maʼlumotlaringiz saqlangan. Oʻzgartirish uchun jonli yordamga murojaat qiling.",
  "identityChangeRequest": "Oʻzgartirish soʻrash",
  "identityChangeReason": "Oʻzgartirish sababi",
  "identitySubmitRequest": "Soʻrovni yuborish",
  "identityChangePending": "Soʻrovingiz koʻrib chiqilmoqda.",
  "identityChangeSubmitted": "Soʻrov yuborildi. Jonli yordam bogʻlanadi.",
  "identityChangeFailed": "Soʻrov yuborilmadi.",
  "identityNoChanges": "Soʻrash uchun oʻzgarish yoʻq.",
  "createdAt": "Hisob yaratilgan",
  "ageIneligible": "Bu tugilgan sana qonuniy yoshdan past. Real pul oyini ochiq emas.",
  "rateOperator": "Suhbatni baholang",
  "ratingComment": "Izoh (ixtiyoriy)",
  "submitRating": "Bahoni yuborish",
  "ratingThanks": "Baho uchun rahmat",
  "footerRules": "Qoidalar",
  "footerPrivacy": "Maxfiylik",
  "rulesLink": "Qoidalar va siyosatlar",
  "footerLegalTitle": "Huquqiy ma’lumot",
  "footerLegalDraftBadge": "QORALAMA",
  "footerLegalDraftNotice": "Quyidagi rekvizitlar faqat mahalliy huquqiy qoralama sifatida berilgan. Kompaniya ro‘yxatdan o‘tishi va litsenziya tasdiqlanguniga qadar ularning tekshirilgani, VBB PLAY litsenziyalanganligi yoki barcha qimor faoliyatini qonuniy amalga oshirish vakolatiga ega ekanligi da’vo qilinmaydi.",
  "footerCompanyLabel": "Kompaniya",
  "footerCompanyName": "Vbb Play Byte Lab Sociedad de Responsabilidad Limitada",
  "footerCountryLabel": "Ro‘yxatdan o‘tish mamlakati",
  "footerCountryValue": "Kosta-Rika",
  "footerRegNumberLabel": "Ro‘yxat raqami",
  "footerRegNumberValue": "2-101-918934",
  "footerAddressLabel": "Yuridik manzil",
  "footerAddressValue": "Provincia 04 San Jose, Canton 02 Escazu, San Rafael, Multiplaza de Escazu kinoteatrlaridan 200 metr janubda, Seiba ko‘chasi, Centro Corporativo EBC, o‘ninchi qavat, Invicta Legal ofisi.",
  "footerLicenseNumberLabel": "Taqdim etilgan litsenziya raqami",
  "footerLicenseNumberValue": "ALSI-207508070-FI1",
  "footerLicenseJurisdictionLabel": "Taqdim etilgan litsenziya yurisdiksiyasi",
  "footerLicenseJurisdictionValue": "Anjuan, Komor orollari Ittifoqi",
  "footerLegalAria": "Huquqiy ma’lumot",
  "footerLegalStatement": "© 2026 VBB Play. vbbplay.com Kosta-Rikada qeydiyyatdan keçmiş Vbb PLay Byte Lab Sociedad de Responsabilidad Limitada şirkətinə məxsusdur və onun tərəfindən idarə olunur, qeydiyyat nömrəsi 2-101-918934, hüquqi ünvanı: Provincia 04 San Jose, Canton 02 Escazu, San Rafael, Multiplaza de Escazu kinoteatrlarından 200 metr cənubda, Seiba küçəsi, Centro Corporativo EBC, onuncu mərtəbə, Invicta Legal ofisi. vbbplay.com Komor Adaları İttifaqının Avtonom Anjuan Adası Hökuməti tərəfindən lisenziyalaşdırılıb və tənzimlənir və ALSI-207508070-FI1 nömrəli lisenziya əsasında fəaliyyət göstərir. VbbPlay.com bütün tənzimləyici tələblərdən keçmişdir və hər cür qumar oyunları və mərc əməliyyatlarını qanuni şəkildə həyata keçirməyə səlahiyyətlidir.",
  "back": "Orqaga",
  "rulesSelectAria": "Huquqiy hujjatni tanlang",
  "scrollToTop": "Yuqoriga",
  "footerAria": "Sayt pastki qismi",
  "footerLiveCasino": "Jonli kazino",
  "footerProviders": "Provayderlar",
  "footerFastGames": "Tez o‘yinlar",
  "footerEsports": "Kiber sport",
  "footerTournaments": "Turnirlar",
  "footerPartnership": "Hamkorlik dasturi",
  "footerTechSupport": "Texnik yordam",
  "footerSupportSecurity": "Yordam va xavfsizlik",
  "footerSocial": "Ijtimoiy tarmoqlar",
  "footerSocialPending": "Rasmiy ijtimoiy hisoblar tasdiqlangach shu yerda ochiladi.",
  "footerAgeHint": "Faqat 18+",
  "footerLegalAccordionTitle": "Huquqiy ma’lumot"
}
